import React, { useState, useContext, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { siteDetailsContext } from "../context/SiteDetailsContext";
import { SelectSiteContext } from "../context/SelectSite";

export default function SideBar() {
  const { siteDetails } = useContext(siteDetailsContext);
  const { setSiteIdFunction, selectedSite } = useContext(SelectSiteContext);
  const [siteId, setSiteId] = useState(localStorage.getItem('currentSideId'));

  useEffect(() => {
    var subscribed = true;
    setSiteIdFunction(siteId)
    return (() => {
      subscribed = false;
    })
  }, [siteId])

  return (
    <>
      <nav className="navbar navbar-vertical navbar-expand-xl navbar-light navbar-glass left-menu">
        <div className="collapse navbar-collapse" id="navbarVerticalCollapse">
          <ul className="navbar-nav flex-column">
            {/* Dashboard */}
            <li className="nav-item">
              <a
                className="nav-link dropdown-indicator"
                href="#dashboard"
                data-toggle="collapse"
                role="button"
                aria-expanded="true"
                aria-controls="dashboard"
              >
                <div className="d-flex align-items-center">
                  <span className="nav-link-icon">
                    <span className="fas fa-tachometer-alt" />
                  </span>
                  <span>Dashboard</span>
                </div>
              </a>
              <ul
                className="nav collapse show"
                id="dashboard"
                data-parent="#navbarVerticalCollapse"
              >
                <li className="nav-item active">
                  <NavLink className="nav-link" to="/dashboard/overview">
                    Overview
                  </NavLink>
                </li>
                <li className="nav-item ">
                  <NavLink className="nav-link" to="/dashboard/geo-report">
                    Geo Report
                  </NavLink>
                </li>
                {/* <li className="nav-item ">
                  <NavLink className="nav-link" to="/analytics">
                    Geek Me Out &nbsp;
                    <span className="badge badge-pill badge-soft-warning">
                      beta
                    </span>
                  </NavLink>
                </li> */}
              </ul>
            </li>
            {/* <li className="nav-item ">
              <NavLink
                className="nav-link dropdown-indicator"
                to="/optin-funnel"
              >
                <div className="d-flex align-items-center">
                  <span className="nav-link-icon">
                    <span className="fas fa-filter" />
                  </span>
                  <span>
                    Optin Funnel
                    <span
                      style={{
                        backgroundColor: "#FFEB3B",
                        color: "#009688",
                      }}
                      className="badge badge-pill badge-success"
                    >
                      Realtime
                    </span>
                  </span>
                </div>
                <i />
              </NavLink>
            </li> */}
            {/* Subscribers */}
            <li className="nav-item">
              <a
                className="nav-link dropdown-indicator"
                href="#subscribers"
                data-toggle="collapse"
                role="button"
                aria-expanded="false"
                aria-controls="subscribers"
              >
                <div className="d-flex align-items-center">
                  <span className="nav-link-icon">
                    <span className="fa fa-users" />
                  </span>
                  <span>Users</span>
                </div>
              </a>
              <ul
                className="nav collapse "
                id="subscribers"
                data-parent="#navbarVerticalCollapse"
              >
                <li className="nav-item ">
                  <NavLink className="nav-link" to="/dashboard/all-users">
                    All Users
                  </NavLink>
                </li>
                {/* <li className="nav-item ">
                  <NavLink className="nav-link" to="/segments">
                    Segments
                  </NavLink>
                </li> */}
              </ul>
            </li>
            {/* Push Notifications */}
            <li className="nav-item">
              <a
                className="nav-link dropdown-indicator"
                href="#notifications"
                data-toggle="collapse"
                role="button"
                aria-expanded="false"
                aria-controls="notifications"
              >
                <div className="d-flex align-items-center">
                  <span className="nav-link-icon">
                    <span className="fa fa-bell" />
                  </span>
                  <span>Push Notifications</span>
                </div>
              </a>
              <ul
                className="nav collapse "
                id="notifications"
                data-parent="#navbarVerticalCollapse"
              >
                <li className="nav-item ">
                  <NavLink className="nav-link" to="/dashboard/campaigns/manual">
                    Notification Response
                  </NavLink>
                </li>
                {/*<li class="nav-item "><a class="nav-link" href="https://app.webpushr.com/triggered-notifications">Automatic Push</a></li>*/}
                <li className="nav-item ">
                  <NavLink className="nav-link" to="/dashboard/campaigns/api">
                    Push via API
                  </NavLink>
                </li>
                <li className="nav-item ">
                  <NavLink className="nav-link" to="/dashboard/campaigns/form">
                    Push via Form
                  </NavLink>
                </li>
                {/* <li className="nav-item ">
                  <NavLink className="nav-link" to="/campaigns/wordpress">
                    Push via WP Plugin
                  </NavLink>
                </li> */}
                {/* <li className="nav-item ">
                  <NavLink className="nav-link" to="/journeys">
                    Journey Builder &nbsp;
                    <span className="badge badge-pill badge-success">NEW</span>
                  </NavLink>
                </li> */}
              </ul>
            </li>
            {/* Websites & Setup */}
            <li className="nav-item">
              <a
                className="nav-link dropdown-indicator"
                href="#websites"
                data-toggle="collapse"
                role="button"
                aria-expanded="false"
                aria-controls="websites"
              >
                <div className="d-flex align-items-center">
                  <span className="nav-link-icon">
                    <span className="fas fa-tools" />
                  </span>
                  <span>Setup</span>
                </div>
              </a>
              <ul
                className="nav collapse "
                id="websites"
                data-parent="#navbarVerticalCollapse"
              >
                <li className="nav-item ">
                  <NavLink className="nav-link" to="/dashboard/optin">
                    Opt-In Prompt
                  </NavLink>
                </li>
                <li className="nav-item ">
                  <NavLink className="nav-link" to="/dashboard/subscription-bell">
                    Subscription Bell
                  </NavLink>
                </li>
                {/* <li className="nav-item ">
                  <NavLink className="nav-link" to="/notification-cards">
                    Notification Cards
                  </NavLink>
                </li> */}
                <li className="nav-item ">
                  <NavLink className="nav-link" to="/dashboard/welcome-push">
                    Welcome Push
                  </NavLink>
                </li>
                <li className="nav-item ">
                  <NavLink className="nav-link" to="/dashboard/site-setting">
                    Site settings
                  </NavLink>
                </li>
                <li className="nav-item ">
                  <NavLink className="nav-link" to="/dashboard/tracking-code">
                    Tracking Code
                  </NavLink>
                </li>
              </ul>
            </li>
            {/* Setup Safari */}
            {/* Logs */}
            <li className="nav-item">
              <a
                className="nav-link dropdown-indicator"
                href="#logs"
                data-toggle="collapse"
                role="button"
                aria-expanded="false"
                aria-controls="logs"
              >
                <div className="d-flex align-items-center">
                  <span className="nav-link-icon">
                    <span className="fa fa-list-alt" />
                  </span>
                  <span>Logs</span>
                </div>
              </a>
              <ul
                className="nav collapse "
                id="logs"
                data-parent="#navbarVerticalCollapse"
              >
                {/* <li className="nav-item ">
                  <NavLink className="nav-link" to="/logs/subscribers">
                    Subscribers
                  </NavLink>
                </li> */}
                <li className="nav-item ">
                  <NavLink className="nav-link" to="/dashboard/logs/attributes">
                    Custom Attributes
                  </NavLink>
                </li>
                {/*<li class="nav-item "><a class="nav-link" href="https://app.webpushr.com/logs/events">Custom Events</a></li>*/}
              </ul>
            </li>
            {/* INTERGRATION */}
            <li className="nav-item">
              <a
                className="nav-link dropdown-indicator"
                href="#integration"
                data-toggle="collapse"
                role="button"
                aria-expanded="false"
                aria-controls="integration"
              >
                <div className="d-flex align-items-center">
                  <span className="nav-link-icon">
                    <span className="fa fa-cog" />
                  </span>
                  <span>Integration</span>
                </div>
                <i />
              </a>
              <ul
                className="nav collapse"
                id="integration"
                data-parent="#navbarVerticalCollapse"
              >
                <li className="nav-item ">
                  <NavLink className="nav-link" to="/dashboard/integration/manual">
                    Manual Integration
                  </NavLink>
                </li>
                {/* <li className="nav-item ">
                  <NavLink
                    className="nav-link"
                    to="/integration/wordpress-plugin"
                  >
                    Wordpress Plugin
                  </NavLink>
                </li> */}
                {/* <li className="nav-item ">
                  <NavLink className="nav-link" to="/integration/rest-api">
                    REST API Keys
                  </NavLink>
                </li> */}
                <li className="nav-item ">
                  <NavLink className="nav-link" to="/dashboard/integration/amp-key">
                    Public key for AMP
                  </NavLink>
                </li>
              </ul>
            </li>
          </ul>
          <div className="px-3 px-xl-0 pb-3 pt-3 navbar-vertical-divider">
            <hr className="border-300 my-2" />
          </div>
          <ul className="navbar-nav flex-column">
            <li className="nav-item ">
              <NavLink
                className="nav-link dropdown-indicator"
                to="/dashboard/data-and-privacy"
              >
                <div className="d-flex align-items-center">
                  <span className="nav-link-icon">
                    <span className="fa fa-lock" />
                  </span>
                  <span>Trust &amp; Privacy</span>
                </div>
                <i />
              </NavLink>
            </li>
          </ul>
          <div className="px-3 px-xl-0 pb-3 pt-3 navbar-vertical-divider">
            <hr className="border-300 my-2" />
          </div>
          <ul className="navbar-nav flex-column">
            {/* <li className="nav-item ">
              <NavLink
                className="nav-link dropdown-indicator"
                to="/uptime-monitoring"
              >
                <div className="d-flex align-items-center">
                  <span className="nav-link-icon">
                    <svg
                      style={{}}
                      id="Capa_1"
                      enableBackground="new 0 0 512.039 512.039"
                      height={16}
                      viewBox="0 0 512.039 512.039"
                      width={16}
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g>
                        <path d="m255.874 67.497c-111.609-97.618-253.518-11.848-255.845 104.427-.593 29.633 7.961 58.498 24.988 85.109h110.364l19.63-32.718c5.7-9.499 19.494-9.805 25.517-.335l41.417 65.083 60.373-127.451c5.265-11.121 20.956-11.474 26.763-.69l51.752 96.111h125.898c93.262-145.76-91.055-311.811-230.857-189.536z" />
                        <path d="m338.667 279.144-41.936-77.881-59.301 125.19c-5.045 10.651-19.884 11.576-26.211 1.632l-42.97-67.523-11.513 19.188c-2.711 4.518-7.593 7.282-12.862 7.282h-95.128c2.982 3.121-12.911-12.74 196.548 195.634 5.85 5.821 15.307 5.822 21.158 0 206.236-205.168 193.572-192.519 196.548-195.634h-111.126c-5.519.001-10.591-3.029-13.207-7.888z" />
                      </g>
                    </svg>
                  </span>
                  <span>
                    Uptime Monitoring &nbsp;
                    <span className="badge badge-pill badge-success">NEW</span>
                  </span>
                </div>
                <i />
              </NavLink>
            </li> */}
          </ul>
          {/* <div className="px-3 px-xl-0 pb-3 pt-3 navbar-vertical-divider">
            <hr className="border-300 my-2" />
          </div> */}
          <ul className="navbar-nav flex-column">
            {/* INTERGRATION */}
            {/* <li className="nav-item">
              <a
                className="nav-link dropdown-indicator"
                href="#troubleshooter"
                data-toggle="collapse"
                role="button"
                aria-expanded="false"
                aria-controls="troubleshooter"
              >
                <div className="d-flex align-items-center">
                  <span className="nav-link-icon">
                    <svg
                      version="1.1"
                      id="Capa_1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 279 279"
                      style={{ enableBackground: "new 0 0 279 279" }}
                      xmlSpace="preserve"
                      width={15}
                      height={15}
                    >
                      <path
                        d="M274.5,103.252V271c0,4.143-2.69,8-6.833,8h-106.49c-4.143,0-7.677-3.857-7.677-8v-52h34.523c8.284,0,15-6.716,15-15
         s-6.716-15-15-15H153.5v-37h34.523c8.284,0,15-6.716,15-15s-6.716-15-15-15H153.5V70.734c0-18.548,5.209-35.83,14.504-49.116
         C177.872,7.517,191.341,0,205.771,0h1.153c4.143,0,7.5,3.169,7.5,7.312c0,25.625,4.832,48.324,13.605,64.254
         C236.914,87.697,248.98,96,263.893,96h3.774C271.81,96,274.5,99.109,274.5,103.252z M91.644,219c-8.284,0-15-6.716-15-15
         s6.716-15,15-15H125.5v-36H91.644c-8.284,0-15-6.716-15-15s6.716-15,15-15H125.5V70.734c0-18.548-4.875-35.83-14.171-49.116
         C101.462,7.517,88.326,0,73.895,0h-1.153c-4.143,0-7.5,3.107-7.5,7.25c0,25.625-4.832,48.51-13.605,64.441
         C42.753,87.822,30.687,96,15.774,96H12c-4.143,0-7.5,3.109-7.5,7.252V271c0,4.143,3.357,8,7.5,8h106.49c4.143,0,7.01-3.857,7.01-8
         v-52H91.644z"
                      />
                    </svg>
                  </span>
                  <span>Troubleshooter</span>
                </div>
                <i />
              </a>
              <ul
                className="nav collapse "
                id="troubleshooter"
                data-parent="#navbarVerticalCollapse"
              >
                <li className="nav-item ">
                  <NavLink className="nav-link" to="/troubleshooter/integration">
                    Test Integration
                    <span className="badge badge-pill badge-soft-warning">
                      beta
                    </span>
                  </NavLink>
                </li>
                <li className="nav-item ">
                  <NavLink className="nav-link" to="/troubleshooter/amp">
                    Test AMP Setup
                    <span className="badge badge-pill badge-soft-warning">
                      beta
                    </span>
                  </NavLink>
                </li>
              </ul>
            </li> */}
            <li className="nav-item">
              <NavLink className="nav-link dropdown-indicator" to="/dashboard/contact-us">
                <div className="d-flex align-items-center">
                  <span className="nav-link-icon">
                    <span className="fa fa-envelope" />
                  </span>
                  <span>Contact Us</span>
                </div>
                <i />
              </NavLink>
            </li>
            <div className="px-3 px-xl-0 pb-3 pt-3 navbar-vertical-divider">
              <hr className="border-300 my-2" />
            </div>
            {/* <li className="nav-item">
              <a className="nav-link dropdown-indicator" href="/">
                <div
                  className="d-flex align-items-center"
                  style={{ color: "gray" }}
                >
                  Connected to: SF233
                </div>
                <i />
              </a>
            </li> */}
          </ul>
        </div>
      </nav>
      <nav className="navbar navbar-vertical navbar-expand-xl navbar-light navbar-glass site-selector">
        <div className="dropdown sites-dropdown text-sans-serif">
          <button
            className="btn  dropdown-toggle"
            id="dropdownSiteButton"
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <img
              alt="img"
              src={selectedSite.icon}
            />
            {selectedSite.siteName}&nbsp;&nbsp;
            <svg
              className="SVGInline-svg SVGInline--cleaned-svg SVG-svg Icon-svg Icon--chevronDown-svg SVG--color-svg SVG--color--gray600-svg"
              style={{ width: "12px", height: "12px" }}
              height={16}
              viewBox="0 0 16 16"
              width={16}
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.591 5.293a1 1 0 0 1 1.416 1.416l-6.3 6.3a1 1 0 0 1-1.414 0l-6.3-6.3A1 1 0 0 1 2.41 5.293L8 10.884z"
                fillRule="evenodd"
              />
            </svg>
          </button>
          <div
            className="dropdown-menu dropdown-menu-left py-0"
            aria-labelledby="dropdownSiteButton"
          >
            <input
              type="text"
              className="form-control filter-sites"
              placeholder="Filter by name..."
              style={{ margin: "-1px 0", border: "none" }}
            // onKeyUp="filterFunction(this)"
            />
            {siteDetails.map((value) => {
              const { _id, siteName, icon } = value;
              return (
                <div key={_id}>
                  <div className="dropdown-divider" />
                  <div
                    className="dropdown-item"
                    onClick={() => setSiteId(_id)}

                  >
                    <img
                      alt="img"
                      src={icon}
                    />
                    {siteName}
                  </div>
                </div>
              );
            })}
            <div className="dropdown-divider" />
            <Link className="dropdown-item text-primary" to="/account/add-site">
              <img
                alt="img"
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjAQMAAAAkFyEaAAAABlBMVEUse+X///+6FDpEAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAFUlEQVQImWNgoAkwQCcZ/2EXpz4AAN+KAiD4IY0wAAAAAElFTkSuQmCC"
              />
              Add New Site
            </Link>
            <div className="dropdown-divider" />
          </div>
        </div>
      </nav>
    </>
  );
}
